import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";

const WA_NUMBER = "16017591868"; // +1 (601) 759-1868
const WA_TEXT = encodeURIComponent("Hello Funded Index Support — I have a question.");
const WA_HREF = `https://wa.me/${WA_NUMBER}?text=${WA_TEXT}`;

export const WhatsAppButton = () => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setMounted(true), 600);
    return () => clearTimeout(t);
  }, []);

  if (typeof document === "undefined") return null;

  const node = (
    <a
      href={WA_HREF}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-chat-button"
      style={{ position: "fixed", bottom: "1.5rem", right: "1.5rem", zIndex: 2147483000 }}
      className={`group inline-flex items-center gap-3
        transition-all duration-500 ease-out
        ${mounted ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"}`}
    >
      {/* Label (desktop only) */}
      <span
        className="hidden sm:inline-flex items-center gap-2 pr-4 pl-4 py-2.5 rounded-full
          bg-[#0a0a0a]/90 border border-[#25D366]/40 backdrop-blur-md
          text-[#f5f5f5] text-sm font-medium tracking-tight
          shadow-[0_4px_18px_rgba(0,0,0,0.45)]
          translate-x-2 opacity-0 group-hover:translate-x-0 group-hover:opacity-100 transition-all duration-300"
      >
        <span className="w-1.5 h-1.5 rounded-full bg-[#25D366] animate-pulse" />
        Chat with us on WhatsApp
      </span>

      {/* Bubble */}
      <span className="relative inline-flex items-center justify-center">
        {/* Pulse ring */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-50 animate-ping" />
        <span
          className="relative inline-flex items-center justify-center w-14 h-14 sm:w-[60px] sm:h-[60px]
            rounded-full bg-[#25D366] text-white
            shadow-[0_8px_28px_rgba(37,211,102,0.55),0_0_0_4px_rgba(37,211,102,0.15)]
            transition-transform duration-200 group-hover:scale-[1.06] group-active:scale-95"
        >
          {/* WhatsApp brand glyph */}
          <svg viewBox="0 0 32 32" className="w-7 h-7 sm:w-8 sm:h-8" aria-hidden="true">
            <path
              fill="currentColor"
              d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.044-.53-.044-.302 0-.53.114-.737.302-.628.586-.916 1.232-.916 2.078v.115c.072 1.131.59 2.106 1.31 2.974 1.357 1.63 3.03 2.989 4.953 3.703.616.229 1.346.444 2.005.444.731 0 1.476-.4 1.92-.997.143-.214.244-.444.302-.687.057-.244.087-.516.057-.788-.014-.115-.043-.215-.085-.315-.243-.444-.901-.358-1.305-.586zM16.002 0C7.176 0 0 7.176 0 16.002a15.9 15.9 0 0 0 2.207 8.118L0 32l8.166-2.118a15.94 15.94 0 0 0 7.836 2.118c8.826 0 16.002-7.176 16.002-16.002C32 7.176 24.828 0 16.002 0zm0 28.943c-2.4 0-4.715-.616-6.717-1.79l-.488-.286-4.872 1.276 1.305-4.758-.315-.503a13.067 13.067 0 0 1-2.062-7.08c0-7.247 5.902-13.15 13.149-13.15 7.247 0 13.149 5.903 13.149 13.15 0 7.246-5.902 13.141-13.149 13.141z"
            />
          </svg>
        </span>
      </span>
    </a>
  );

  return createPortal(node, document.body);
};
